module.exports = __webpack_public_path__ + "static/img/banner-oportunidades-home-1680x1050.50767fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-oportunidades-home-1680x1050.jpg
// module id = fTiy
// module chunks = 47